import React from 'react';
import { Link } from 'react-router-dom';

const DasboardCard = ({color,action,date,time,name,specialization}) => {
  return (
    <div className="review_card patient_dashboard_card py-4">
      <div className="container-fluid">
        <div className="row mb-3 px-3">
          <div className="col px-0">
            <h4 className="font-weight-bold">{name}</h4>
            <p className="font-smaller">{specialization}</p>
          </div>
          <div className="col text-right px-0 text-warning py-2">
            <div className="d-inline-flex align-items-center">
              <span className="box d-inline-block mr-2" style={{backgroundColor: color}}></span>
              <span style={{color}}>{action}</span>
            </div>
          </div>
        </div>
        <div className="row mb-4">
          <div className="col-6">
            <div className="font-smaller footer_link">
              <span className="check d-inline-block mr-1 h6">@</span> <span> {time} </span>
            </div>
          </div>
          <div className="col-6">
            <div className="font-smaller footer_link">
              <span className="check d-inline-block mr-1 h6">@</span> <span>{date} </span>
            </div>
          </div>
        </div>
          <div>
            <div className="text-right text-uppercase">
              <Link className="check " to="/">Full Info</Link>
            </div>
          </div>
      </div>
    </div>
  );
};

export default DasboardCard;